import { makeAutoObservable, reaction } from "mobx";
import agent from "shared/agent";
import mapaStore from "../stores/mapa";

class AuthStore {
  sessaoGuidId = "";

  refreshTokenSessao = "";

  appLoaded = false;

  usuario = null;

  empresa = null;

  constructor() {
    makeAutoObservable(this);
    reaction(
      () => this.sessaoGuidId,
      (sessaoGuidId) => {
        if (sessaoGuidId) {
          window.localStorage.setItem("sessaoGuidId", sessaoGuidId);
        } else {
          window.localStorage.removeItem("sessaoGuidId");
        }
      }
    );

    reaction(
      () => this.refreshTokenSessao,
      (refreshTokenSessao) => {
        if (refreshTokenSessao) {
          window.localStorage.setItem("refreshTokenSessao", refreshTokenSessao);
        } else {
          window.localStorage.removeItem("refreshTokenSessao");
        }
      }
    );
  }

  checarSessao() {
    this.loadingUser = true;
    return agent.Auth.checarSessao().then((res) => {
      if (res.CodigoRetorno === 1) {
        this.setUsuario(res.Usuario);
        this.setSessaoGuidId(res.SessaoGuidId);
        this.setRefreshTokenSessao(res.RefreshTokenSessao);
        mapaStore.setOrigem(res.Empresa.Latitude, res.Empresa.Longitude)
        mapaStore.setModoDistribuicao(res.Empresa.ModoDistribuicao)
      } else {
        this.setSessaoGuidId(null);
        this.setRefreshTokenSessao(null);
        throw res;
      }
    });
  }

  logout() {
    agent.Auth.logout().then(() => {
      this.setLogin("");
      this.setSenha("");
      this.setSessaoGuidId(null);
      this.setRefreshTokenSessao(null);
    });
    return Promise.resolve();
  }

  setSessaoGuidId(sessaoGuidId) {
    this.sessaoGuidId = sessaoGuidId;
  }

  setRefreshTokenSessao(refreshTokenSessao) {
    this.refreshTokenSessao = refreshTokenSessao;
  }

  setUsuario(usuario) {
    this.usuario = usuario;
  }

  setEmpresa(empresa) {
    this.empresa = empresa;
  }

  setAppLoaded() {
    this.appLoaded = true;
  }

  setAppUnloaded() {
    this.appLoaded = true;
  }
}

export default new AuthStore();
